'use client';

import dynamic from 'next/dynamic';

/**
 * The one deferral point for `DonateCard`.
 *
 * `DonateCard` is `'use client'` and pulls the whole donate form graph with it
 * (context, form, the four selectors, action hooks). Every variant that renders
 * it — `donate-shim`, `donate-profound`, `donate-interstitial`, and
 * `organisms-experiments/donate-profound-vertical` — is a Server Component, and
 * the component registry is reachable from the root layout, so a static import
 * puts that graph in the shared client chunk on every page.
 *
 * Next.js does not automatically code-split a Client Component when a Server
 * Component calls `dynamic()`. This module is intentionally a thin Client
 * Component wrapper so every Server Component variant gets the supported
 * client-owned dynamic boundary without duplicating it.
 *
 * This can't be expressed in `donate.definition.ts`: `lazyCms` wraps
 * `next/dynamic`, which creates a client boundary, so applying it to those
 * Server Component variants would pull their own server-only code into the
 * client bundle instead of removing anything. The deferral has to happen where
 * the client child is rendered, so it lives here once and the variants import
 * from this module rather than each calling `dynamic()` themselves.
 *
 * `ssr` is left on (the default), so the card is still server-rendered for
 * markup and LCP; only its hydration JS moves to an on-demand chunk.
 */
export const DonateCard = dynamic(() =>
  import('./donate-card.tsx').then((m) => m.DonateCard),
);
